const STORAGE_KEY = 'hlm-manual-wizard-snapshot';

export function saveManualWizardSnapshot(snapshot) {
  if (!snapshot || snapshot.isSantralFlow || snapshot.onServisKaydiId) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...snapshot, savedAt: Date.now() }));
  } catch {
    /* ignore */
  }
}

export function loadManualWizardSnapshot() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.isSantralFlow || parsed?.onServisKaydiId) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearManualWizardSnapshot() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
